import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentTypeValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'string',
            empty: false,
            mandatory: false
        };
    }
}
